import { render, staticRenderFns } from "./ExpedienteEntryView.vue?vue&type=template&id=a2d6ba94&"
import script from "./ExpedienteEntryView.vue?vue&type=script&lang=js&"
export * from "./ExpedienteEntryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {
  VCard,
})
